function renumberDeviceRows() {
    $('#devicesTableBody tr').each(function(i) {
        $(this).find('.row-num').first().text(i + 1);
    });
}
renumberDeviceRows();

$('.adddevice-btn').on('click', function() {
    $.ajax({
        url: '/api/device/modal/add',
        method: 'GET',
    }).done(function(response) {
            const dialog = new Dialog("Add Device", `${response.html}`, { size: "2xl" });
            
            dialog.setButtons([
                {
                    name: "Cancel",
                    dismiss: true,
                },
                {
                    name: "Add Device",
                    class: "bg-green-600 text-white hover:bg-green-700",
                    onClick: function() {
                        const btn = $(this);
                        const loadingBtn = new LoadingButton(btn);
                        loadingBtn.start();
                        const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                        const name = $('#deviceName').val();
                        const protocol = $('#protocol').val();
                        const tag = $('#dtag').val();
                        const deviceType = $('#dtype').val();
                        const description = $('#description').val();
                        const dev_eui = $('#dev_eui').val();
                        const appkey = $('#appkey').val();
                        const joineui = $('#joineui').val();
                        const dprofile = $('#dprofile').val();
                        const user_id = $('#m-userSearch').attr('data-id');

                        if (deviceType === "worker"){
                            if (!user_id) {
                                loadingBtn.stop();
                                Toast.show("Please select a user", "error", 3000);
                                return;
                            }
                        }

                        if (protocol === "lora") {
                            if (!dev_eui || !appkey || !joineui || !dprofile) {
                                loadingBtn.stop();
                                Toast.show("Please fill all required fields", "error", 3000);
                                return;
                            }
                        }
                        const protocol_id = $('#protocol option:selected').data('id');
                        
                        $.ajax({
                            url: '/api/device/create',
                            method: 'POST',
                            headers: {
                                'X-CSRFToken': csrftoken
                            },
                            data: {
                                name: name,
                                protocol: protocol,
                                protocol_id: protocol_id,
                                device_type: deviceType,
                                tag: tag,
                                description: description,
                                dev_eui: dev_eui,
                                app_key: appkey,
                                join_eui: joineui,
                                device_profile_id: dprofile,
                                user_id: user_id
                            }
                        }).done(function(response) {
                            loadingBtn.stop();
                            dialog.hide();
                            Toast.show(response.message, "success", 3000); 
                            const table = $('#devicesTableBody');
                            const newRow = `
                            <tr class="hover:bg-slate-50">
                                <td class="px-4 py-4 text-sm text-slate-700 row-num"></td>
                                <td class="px-4 py-4">
                                    <div class="flex items-center gap-3">
                                    <div>
                                        <div class="font-medium text-slate-900">${response.device.name}</div>
                                        ${response.device.dev_eui ? `<div class="text-sm text-slate-500">${response.device.dev_eui}</div>` : ''}
                                    </div>
                                    </div>
                                </td>
                                <td class="px-4 py-4 text-sm text-slate-700">${response.device.assigned_user}</td>
                                <td class="px-4 py-4">
                                    <span class="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">${response.device.tag}</span>
                                </td>
                                <td class="px-4 py-4">
                                    <div class="flex items-center gap-2">
                                    <span class="inline-flex items-center rounded-full bg-red-50 text-red-700 ring-red-600/20 px-2 py-1 text-xs font-medium ring-1 ring-inset">Offline</span>
                                    </div>
                                </td>
                                <td class="px-4 py-4 text-sm text-slate-700">None</td>
                                <td class="px-4 py-4 text-sm text-slate-700">${new Date(response.device.created_at).toISOString().split('T')[0]}</td>
                                <td class="px-4 py-4">
                                    <div class="flex items-center justify-center gap-2">
                                    <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-200 view-logs cursor-pointer" title="View logs" data-device-id="${response.device.id}">
                                        <i class="bi bi-file-earmark-text-fill"></i>
                                    </button>
                                    <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-200 device-info cursor-pointer" title="Device settings" data-device-id="${response.device.id}" data-dev-eui="${response.device.dev_eui}">
                                        <i class="bi bi-gear-fill"></i>
                                    </button>
                                    <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-red-200 text-red-600 hover:bg-red-200 cursor-pointer delete-device" title="Delete device" data-device-id="${response.device.id}" data-dev-eui="${response.device.dev_eui}">
                                        <i class="bi bi-trash3-fill"></i>
                                    </button>
                                    </div>
                                </td>
                                </tr>
                                `;
                            table.prepend(newRow);
                            renumberDeviceRows();
                        }).fail(function(error) {
                            loadingBtn.stop();
                            Toast.show(error.responseJSON.error, "error", 3000);
                        });
                    }
                }
            ]);
            dialog.show();
            $('#protocol').on('change', function() {
                const protocol = $(this).val();
                if (protocol === "lora") {
                    $('.lorawanFields').removeClass('hidden');
                } else {
                    $('.lorawanFields').addClass('hidden');
                }
            });
            $('#dtype').on('change', function() {
                const deviceType = $(this).val();
                if (deviceType === "worker") {
                    $('.userAssignment').removeClass('hidden');
                } else {
                    $('.userAssignment').addClass('hidden');
                }
            });
            initDeviceUserSearch('m');
        });
    });

/**
 * Wires a device modal's worker picker — same behaviour as the task worker
 * pickers: the roster drops open on focus and pages in on scroll, typing filters
 * it. `prefix` is the modal's element-id prefix — 'm' for Add Device, 'i' for
 * Device Info. The chosen user id ends up on the input as data-id.
 */
function initDeviceUserSearch(prefix) {
    const userSearchInput = $(`#${prefix}-userSearch`);
    if (!userSearchInput.length) return;

    const userDropdown = $(`#${prefix}-userDropdown`);
    const userSearchLoading = $(`#${prefix}-userSearchLoading`);
    const userHoverTooltip = $(`#${prefix}-userHoverTooltip`);

    UserTooltip(userHoverTooltip, userSearchInput);

    initPaginatedWorkerSearch(userSearchInput, userDropdown, userSearchLoading, function(user) {
        userSearchInput.val(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || String(user.id));
        userSearchInput.attr('data-id', user.id);
        userSearchInput.data('user', user);
        userDropdown.addClass('hidden');
        // .val() fires no event — the Info modal's "any field changed" gate needs
        // one to enable the save button.
        userSearchInput.trigger('change');
    });

    // Typing over a picked name drops the selection, so a stale id can never be
    // submitted with a name the admin has since edited.
    userSearchInput.on('input.assign', function() {
        const picked = $(this).data('user');
        const pickedName = picked
            ? `${picked.first_name || ''} ${picked.last_name || ''}`.trim() || picked.username || String(picked.id)
            : '';
        if ($(this).val().trim() !== pickedName) {
            userSearchInput.removeAttr('data-id');
            userSearchInput.removeData('user');
            userHoverTooltip.addClass('hidden');
        }
    });
}

$(document).on('click', function(event) {
    ['m', 'i'].forEach(function(prefix) {
        if (!$(event.target).closest(`#${prefix}-userDropdown, #${prefix}-userSearch`).length) {
            $(`#${prefix}-userDropdown`).addClass('hidden');
        }
    });
});

$(document).on('click', '.device-info', function() {
    const deviceId = $(this).data('device-id');
    const devEui = $(this).data('dev-eui');
    $.ajax({
        url: `/api/device/modal/info`,
        method: 'GET',
        data: {
            device_id: deviceId,
            dev_eui: devEui

        }
    }).done(function(response) {
            
            const dialog = new Dialog("Device Info", `${response.html}`, { size: "2xl" });
            
            dialog.setButtons([
                {
                    name: "Cancel",
                    dismiss: true,
                },
                {
                    name: "Update Device",
                    class: "bg-green-600 text-white hover:bg-green-700 update-device-btn",
                    onClick: function() {
                        const btn = $(this);
                        const loadingBtn = new LoadingButton(btn);
                        loadingBtn.start();

                        const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                        const name = $('#deviceName').val();
                        const tag = $('#dtag').val();
                        const deviceType = $('#dtype').val();
                        const protocol = $('#protocol').val();
                        const description = $('#description').val();
                        const appkey = $('#appkey').val();
                        const joineui = $('#joineui').val();
                        const dprofile = $('#dprofile').val();

                        // Only present when the device is currently unassigned.
                        const $assignInput = $('#i-userSearch');
                        const assignUserId = $assignInput.attr('data-id');
                        if ($assignInput.length && $assignInput.val().trim() && !assignUserId) {
                            loadingBtn.stop();
                            Toast.show("Please select a user from the list", "error", 3000);
                            return;
                        }

                        $.ajax({
                            url: '/api/device/update',
                            method: 'POST',
                            headers: {
                                'X-CSRFToken': csrftoken
                            },
                            data: {
                                device_id: deviceId,
                                dev_eui: devEui,
                                name: name,
                                tag: tag,
                                device_type: deviceType,
                                description: description,
                                app_key: appkey,
                                join_eui: joineui,
                                device_profile_id: dprofile,
                                protocol: protocol,
                                user_id: assignUserId
                            }
                        }).done(function(response) {
                            loadingBtn.stop();
                            dialog.hide();
                            Toast.show(response.message, "success", 3000);
                            if (response.assigned_user) {
                                $(`button.device-info[data-device-id="${deviceId}"]`)
                                    .closest('tr').find('td').eq(2).text(response.assigned_user);
                            }
                        }).fail(function(error) {
                            loadingBtn.stop();
                            Toast.show(error.responseJSON.error, "error", 3000);
                        });
                    }
                }
            ]);
            dialog.show();
            initDeviceUserSearch('i');
            const $modal = $(dialog.modal);
            const original = {};
            $modal.find('input, select, textarea').each(function() {
                original[this.id] = $(this).val();
            });
            function anyFieldChanged() {
                let changed = false;
                $modal.find('input, select, textarea').each(function() {
                    if ($(this).val() != original[this.id]) {
                        changed = true;
                        return false; // break
                    }
                });
                return changed;
            }
            $modal.find('input, select, textarea').on('input change', function() {
            const btn = $modal.find('.update-device-btn');
            if (anyFieldChanged()) {
                
                btn.prop('disabled', false);
                btn.removeClass('cursor-not-allowed');
                btn.addClass('hover:bg-green-700 cursor-pointer');
                btn.css('opacity', 1);
            } else {
                btn.css('opacity', 0.5);
                btn.removeClass('hover:bg-green-700 cursor-pointer');
                btn.addClass('cursor-not-allowed');
                btn.prop('disabled', true);
            }
        }).trigger('change');

        }).fail(function(error) {
        Toast.show(error.responseJSON?.error || "Failed to load device info.", "error", 3000);
    });
    });
    

$(document).on('click', '.delete-device', function() {
    const deviceId = $(this).data('device-id');
    const devEui = $(this).data('dev-eui');
    const dialog = new Dialog("Delete Device", `<p>Are you sure you want to delete this device?</p>`, { size: "md" });
    dialog.setButtons([
        {
            name: "Cancel",
            dismiss: true,
        },
        {
            name: "Delete",
            class: "bg-red-600 text-white hover:bg-red-700",
            onClick: function() {
                const btn = $(this);
                const loadingBtn = new LoadingButton(btn);
                loadingBtn.start();
                const csrftoken = $("[name=csrfmiddlewaretoken]").val();
                $.ajax({
                    url: '/api/device/delete',
                    method: 'POST',
                    headers: {
                        'X-CSRFToken': csrftoken
                    },
                    data: {
                        device_id: deviceId,
                        dev_eui: devEui
                    }
                }).done(function(response) {
                    loadingBtn.stop();
                    dialog.hide();
                    Toast.show(response.message, "success", 3000);
                    $(`button[data-device-id="${deviceId}"]`).closest('tr').remove();
                    renumberDeviceRows();
                }).fail(function(error) {
                    loadingBtn.stop();
                    Toast.show(error.responseJSON.error, "error", 3000);
                });
            }
        }
    ]);
    dialog.show();
});


function UserTooltip(tooltip,userSearchInput){
    const userHoverTooltip = tooltip;
        userSearchInput.on('mouseenter', function() {
            const userData = $(this).data('user');
            
            const userId = $(this).data('id');
            if (userData && userId) {
                userHoverTooltip.find('#tooltip-name').text(`${userData.first_name} ${userData.last_name}`);
                userHoverTooltip.find('#tooltip-details').html(`
                    <span class="font-mono">${userData.credentials?.username || 'N/A'}</span> • 
                    <span>${userData.email}</span>
                `);

                userHoverTooltip.find('#tooltip-tags').html(`<span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded">${userData.tags[0]}</span>`);

                const inputOffset = $(this).position();
                userHoverTooltip.css({
                    top: inputOffset.top - userHoverTooltip.outerHeight() - 5,
                    left: inputOffset.left
                });
                
                userHoverTooltip.removeClass('hidden');
            } else if (userHoverTooltip.attr('data-tooltip') === "1") {
                const inputOffset = $(this).position();
                userHoverTooltip.css({
                    top: inputOffset.top - userHoverTooltip.outerHeight() - 5,
                    left: inputOffset.left
                });
                
                userHoverTooltip.removeClass('hidden');
            }
        }).on('mouseleave', function() {
            userHoverTooltip.addClass('hidden');
        });
        
        userHoverTooltip.on('mouseenter', function() {
            $(this).removeClass('hidden');
        }).on('mouseleave', function() {
            $(this).addClass('hidden');
    });
}

function assignUserItem(user, userSearchInput, userDropdown, multiSelect = false, isSelected = false) {
    let checkboxHtml = '';
    if (multiSelect) {
        checkboxHtml = `<input type="checkbox" class="mr-3 mt-1 w-4 h-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500 focus:ring-2 pointer-events-none" ${isSelected ? 'checked' : ''} />`;
    }

    const userItem = $(`
        <div class="px-4 py-3 hover:bg-slate-50 cursor-pointer border-b border-slate-100 last:border-b-0 flex items-start" data-user-id="${user.id}">
            ${checkboxHtml}
            <div class="flex flex-col flex-1">
                <div class="font-medium text-sm text-slate-900">
                    ${user.first_name || ''} ${user.last_name || ''}
                </div>
                <div class="text-xs text-slate-600 mt-1 flex items-center gap-2">
                    <span class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded font-mono">${user.emp_id || '-'}</span>
                    <span class="font-mono">${user.username || 'N/A'}</span>
                </div>
            </div>
        </div>
    `);

        userItem.on('click', function() {

            userSearchInput.val(`${user.first_name} ${user.last_name}`);
            
            userSearchInput.attr('data-id', user.id);
            
            // Store user data for hover display
            userSearchInput.data('user', user);
        
            userDropdown.addClass('hidden');
        });

        return userItem;
    }

// searchUser() and searchUserPaginated() now live in user.js (grouped with user code).

/**
 * Generic initializer for paginated worker search dropdowns (e.g. for assignee or single-select)
 */
function initPaginatedWorkerSearch($input, $dropdown, $loading, onSelect, staticWorkers = null, multiSelect = false, getSelectedIds = null) {
    let offset = 0, total = 0, loading = false, query = '', searchTimeout = null;
    const PAGE_SIZE = 15;

    $input.off('input.paginated focus.paginated click.paginated');
    $dropdown.off('scroll.paginated');

    function fetchWorkers(append) {
        if (loading) return;
        if (append && offset >= total && total > 0) return;
        loading = true;
        if (!append) {
            $loading.removeClass('hidden');
            $dropdown.empty();
        }

        if (staticWorkers) {
            setTimeout(function() {
                const q = query.toLowerCase();
                const filtered = staticWorkers.filter(u => {
                    if (!q) return true;
                    const name = `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.user_name || u.username || '';
                    return name.toLowerCase().includes(q) || 
                           String(u.id || u.user_id).includes(q) || 
                           (u.emp_id && String(u.emp_id).includes(q));
                });
                total = filtered.length;
                const slice = filtered.slice(offset, offset + PAGE_SIZE);
                
                if (slice.length === 0 && offset === 0) {
                    $dropdown.append('<div class="px-4 py-3 text-sm text-slate-500 text-center">No workers found</div>');
                } else {
                    const selectedIds = getSelectedIds ? getSelectedIds() : [];
                    slice.forEach(function (user) {
                        const isSelected = selectedIds.includes(String(user.id)) || selectedIds.includes(user.id);
                        const item = assignUserItem(user, $input, $dropdown, multiSelect, isSelected);
                        item.off('click').on('click', function(e) {
                            e.stopPropagation();
                            if (multiSelect) {
                                const $chk = item.find('input[type="checkbox"]');
                                const currentlyChecked = $chk.is(':checked');
                                $chk.prop('checked', !currentlyChecked);
                                if (onSelect) {
                                    onSelect(user, !currentlyChecked);
                                }
                            } else {
                                if (onSelect) {
                                    onSelect(user);
                                } else {
                                    $input.val(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || String(user.id));
                                    $input.attr('data-id', user.id);
                                    $input.data('user', user);
                                }
                                $dropdown.addClass('hidden');
                            }
                        });
                        $dropdown.append(item);
                    });
                }
                offset += slice.length;
                $dropdown.removeClass('hidden');
                loading = false;
                $loading.addClass('hidden');
            }, 50);
            return;
        }

        searchUserPaginated({ limit: PAGE_SIZE, offset: offset, query: query })
            .done(function (resp) {
                const users = resp.users || [];
                total = resp.total || 0;
                
                if (users.length === 0 && offset === 0) {
                    $dropdown.append('<div class="px-4 py-3 text-sm text-slate-500 text-center">No workers found</div>');
                } else {
                    const selectedIds = getSelectedIds ? getSelectedIds() : [];
                    users.forEach(function (user) {
                        const isSelected = selectedIds.includes(String(user.id)) || selectedIds.includes(user.id);
                        const item = assignUserItem(user, $input, $dropdown, multiSelect, isSelected);
                        item.off('click').on('click', function(e) {
                            e.stopPropagation();
                            if (multiSelect) {
                                const $chk = item.find('input[type="checkbox"]');
                                const currentlyChecked = $chk.is(':checked');
                                $chk.prop('checked', !currentlyChecked);
                                if (onSelect) {
                                    onSelect(user, !currentlyChecked);
                                }
                            } else {
                                if (onSelect) {
                                    onSelect(user);
                                } else {
                                    $input.val(`${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || String(user.id));
                                    $input.attr('data-id', user.id);
                                    $input.data('user', user);
                                }
                                $dropdown.addClass('hidden');
                            }
                        });
                        $dropdown.append(item);
                    });
                }
                offset += users.length;
                $dropdown.removeClass('hidden');
            })
            .always(function () {
                loading = false;
                $loading.addClass('hidden');
            });
    }

    $input.on('input.paginated', function () {
        clearTimeout(searchTimeout);
        const newQuery = $(this).val().trim();
        searchTimeout = setTimeout(function () {
            if (!staticWorkers && newQuery.length > 0 && newQuery.length < 3) {
                Toast.show("Please enter at least 3 characters", "error", 3000);
                return;
            }
            query = newQuery;
            offset = 0; total = 0;
            fetchWorkers(false);
        }, 400);
    });

    $input.on('focus.paginated click.paginated', function(e) {
        e.stopPropagation();
        if ($dropdown.hasClass('hidden')) {
            query = $input.val().trim();
            offset = 0; total = 0;
            fetchWorkers(false);
        }
    });

    $dropdown.on('scroll.paginated', function () {
        if (this.scrollTop + this.clientHeight >= this.scrollHeight - 20) {
            fetchWorkers(true);
        }
    });
}

$(document).on('click', '.view-logs', function() {
    const deviceId = $(this).data('device-id');
    $.ajax({
        url: '/api/device/logs',
        method: 'GET',
        data: {
            device_id: deviceId,
        }
    }).done(function(response) {
        const drawer  = new Drawer("Device Logs", `${response.html}`, { width: 'lg:max-w-7xl md:max-w-3xl w-auto'});

        window._logDrawerBlocks = response.blocks;

        drawer.setEvents([{
            action: 'show',
            callback: function() {
                initLogMap();
            }
        }]);
        drawer.show();
    }).fail(function(error) {
        Toast.show(error.responseJSON.error, "error", 3000);
    });
});

function loadLeaflet(callback) {
    if (typeof L !== 'undefined') {
        callback();
        return;
    }

    // Load CSS
    if (!document.querySelector('link[href*="leaflet"]')) {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        css.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
        css.crossOrigin = '';
        document.head.appendChild(css);
    }

    // Load JS
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    script.crossOrigin = '';
    script.onload = callback;
    document.head.appendChild(script);
}

function initLogMap() {
    const mapEl = document.getElementById('logMap');
    if (!mapEl) return;

    loadLeaflet(function() {
        _initLogMapInstance();
    });
}

function _initLogMapInstance() {
    const map = L.map('logMap').setView([5.3926745933572935, 102.22839145415885], 16);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 22,
    }).addTo(map);

    const imageUrl = 'https://nh.ectrons.com/static/images/location/map1.png';
    const imageBounds = [
        [5.3882710000000005, 102.21009100000002],
        [5.428189000000001, 102.23435300000001]
    ];
    L.imageOverlay(imageUrl, imageBounds, { opacity: 0.9, interactive: true }).addTo(map);

    // Add blocks layer
    const blocksData = window._logDrawerBlocks;
    if (blocksData) {
        L.geoJSON(blocksData, {
            style: {
                color: 'rgba(0, 0, 0, 0.47)',
                weight: 1,
                fillColor: 'rgba(66, 255, 69, 0.19)',
                fillOpacity: 0.5
            },
            onEachFeature: function(feature, layer) {
                const name = feature?.name ?? 'Unnamed';
                layer.bindTooltip(name, {
                    permanent: true,
                    direction: 'center',
                    className: 'custom-tooltip'
                });
            }
        }).addTo(map);
    }

    let marker = null;

    // Find first row with location and place marker
    const firstRow = document.querySelector('.log-row.has-location');
    if (firstRow) {
        const lat = parseFloat(firstRow.dataset.lat);
        const lng = parseFloat(firstRow.dataset.lng);
        if (lat && lng) {
            marker = L.marker([lat, lng]).addTo(map);
            marker.bindPopup(`<b>Lat:</b> ${lat}<br><b>Lng:</b> ${lng}`).openPopup();
            map.setView([lat, lng], 18);
            $('#logMapCoords').text(`${lat.toFixed(6)}, ${lng.toFixed(6)}`);
            firstRow.classList.add('bg-blue-50');
        }
    }

    // Click on any log row to move marker
    $(document).on('click', '.log-row.has-location', function() {
        const lat = parseFloat($(this).data('lat'));
        const lng = parseFloat($(this).data('lng'));
        if (!lat || !lng) return;

        // Remove highlight from all rows
        $('.log-row').removeClass('bg-blue-50');
        $(this).addClass('bg-blue-50');

        if (marker) {
            marker.setLatLng([lat, lng]);
            marker.setPopupContent(`<b>Lat:</b> ${lat}<br><b>Lng:</b> ${lng}`).openPopup();
        } else {
            marker = L.marker([lat, lng]).addTo(map);
            marker.bindPopup(`<b>Lat:</b> ${lat}<br><b>Lng:</b> ${lng}`).openPopup();
        }
        map.setView([lat, lng], 18);
        $('#logMapCoords').text(`${lat.toFixed(6)}, ${lng.toFixed(6)}`);
    });
}